import ExternalLink from "../../ExternalLink";
import TableDataColumn1 from "./TableDataColumn1";
import TableDataColumn2 from "./TableDataColumn2";
import TableDataColumn3 from "./TableDataColumn3";

export default function SpecifyOutputRequirements() {
  const loginUrl = "https://timephasing.promineo.com";

  return(
    <div className="flex">
      <div className="bg-promLightGreen1">
        <div className="ml-2">
          <div className="font-inter text-24px">
            3 - Specify output requirements
          </div>
          <div className="font-inter text-base">
            What output are you looking for? <br/>
            Weekly, Monthly or Daily periods? <br/> 
            Perhaps grouped by something?
          </div>
        </div>
        
        <div className="bg-promLightGreen3 pb-4">
          <table className="mt-4 font-inter">
            <tr className="bg-promLightGreen2">
              <td className="text-right pr-2">Property</td>
              <td>Selection</td>
              <td className="text-left pl-2">Description</td>
            </tr>
            <tr>
              <TableDataColumn1 description={"Granularity"} />
              <TableDataColumn2 description={"Week"} />
              <TableDataColumn3 description={"Select granularity of returned periods (day, week, month, ...)"} />
            </tr>
            <tr>
              <TableDataColumn1 className="pl-2" description={"First day of week"} />
              <TableDataColumn2 description={"Monday"} />
              <TableDataColumn3 description={"If, granularity is weeks, set first day of week(Sun, Mon, ...)"} />
            </tr>
            <tr>
              <TableDataColumn1 description={"Group by"} />
              <TableDataColumn2 description={"Wbs"} />
              <TableDataColumn3 description={"Your field [Wbs] is grouped by timePhasing"} />
            </tr>
          </table>

          <div className="ml-8 mt-8">
            Login and get your free token key here: <br/>
            <ExternalLink url={loginUrl} />
          </div>
          <div className="ml-24">
            <table className="mt-4 font-inter">
              <tr>
                <TableDataColumn1 description={"Token key"} />
                <TableDataColumn2 className="w-10/12" description={""} />
              </tr>
            </table>
          </div>

        </div>
        
      </div>
    </div>
  );
}